import { useCallback, useMemo } from 'react';
import { usePortal } from '../contexts/PortalContext';
import { buildTokens, fillTemplate } from '../utils/template';

export function useTokens() {
  const { answers } = usePortal();
  const tokens = useMemo(() => buildTokens(answers), [answers]);
  const fill = useCallback((s: string) => fillTemplate(s, tokens), [tokens]);
  return { tokens, fill };
}
